import { enableProdMode, importProvidersFrom, runInInjectionContext } from '@angular/core';
import { environment } from './environments/environment';
import { APP_BASE_HREF } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular/standalone';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiModule } from './app/api/api.module';
import { ApiModule as ApiModuleMsp } from './app/msp-api/api.module';
import { AppRoutingModule } from './app/app-routing.module';
import { CoreModule } from './app/core/core.module';
import { provideNgxStripe } from 'ngx-stripe';
import { TranslatesBrowserModule } from 'src/shared/translates/translates-browser';
import { AppComponent } from './app/app.component';
import { InitializedService } from 'src/shared/services/helpers/initialized.service';
import { TranslatesService } from 'src/shared/translates';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from './app/app.module';
import { register } from 'swiper/element/bundle';
import 'swiper/element/bundle';

register();

if (environment.production) {
  enableProdMode();
}

async function runAppInitializers() {
  const injector = await bootstrapApplication(AppComponent, {
    providers: [
      provideHttpClient(withInterceptorsFromDi()),
      importProvidersFrom(
        ApiModule.forRoot({ rootUrl: !document.location.origin.includes('localhost') ? document.location.origin : environment.api }),
        ApiModuleMsp.forRoot({ rootUrl: !document.location.origin.includes('localhost') ? document.location.origin : environment.api }),
        AppRoutingModule,
        CoreModule,
        TranslatesBrowserModule,
        TranslateModule.forRoot({
          loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
          }
        }),
      ),
      provideNgxStripe(),
      { provide: APP_BASE_HREF, useValue: '/app/' },
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      provideAnimations(),
      provideIonicAngular({innerHTMLTemplatesEnabled: true, rippleEffect: false}),
    ]
  }).then(injector => {
    return runInInjectionContext(injector.injector, async () => {
      const translatesService = injector.injector.get(TranslatesService);
      await translatesService.initLanguage();
      const initService = injector.injector.get(InitializedService);
      await initService.initData();
    });
  }).catch(err => {
  });
}

runAppInitializers().catch(err => {
  console.error('App initialization failed:', err);
});